/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Share_StreakInputs */

const en_us2_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the streak`)
};

const pt_br2_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar a sequência`)
};

const es_419_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir la racha`)
};

const pt_pt2_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar a sequência`)
};

const fr_fr2_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager la série`)
};

const de_de2_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie teilen`)
};

const it_it2_share_share_streak = /** @type {(inputs: Share_Share_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi la serie di settimane`)
};

/**
* | output |
* | --- |
* | "Share the streak" |
*
* @param {Share_Share_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_share_streak = /** @type {((inputs?: Share_Share_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Share_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_share_streak(inputs)
	if (locale === "es-419") return es_419_share_share_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_share_share_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_share_share_streak(inputs)
	if (locale === "de-DE") return de_de2_share_share_streak(inputs)
	if (locale === "it-IT") return it_it2_share_share_streak(inputs)
	return en_us2_share_share_streak(inputs)
});
export { share_share_streak as "share.share_streak" }